import { IconImage } from "@/components";
import {
  delete_img,
  shield_admin_img,
  unlock_right,
  userRightsEnums,
  view_only_user_img,
} from "@/constants";
import { useAppSelector } from "@/store";
import { formatAndCapitalize, formatDateOrTime } from "@/utils";
import { Box, Button, Typography } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { StyledContainedButton } from "../SPOWNER/clients/styles";
import { StyledAvatar, StyledChip } from "./styles";
import { tokens } from "@/tokens";

export const useUserColumns = (
  handleEditUser: (obj: usersManagementModal) => void
): IColumn<IUser>[] => {
  const { user } = useAppSelector((state) => state.auth);
  const isCurrentUserAdmin = user?.accessLevel === userRightsEnums.admin;
  const getFormatedDate = (
    date: Date | string | undefined,
    dateType: "date" | "time" | "both" = "date"
  ) => {
    return date && formatDateOrTime(new Date(date), dateType);
  };

  const handleEditFn = (param: IUser) => {
    if (!isCurrentUserAdmin) return;
    handleEditUser({
      type: "edit",
      data: param,
    });
  };

  return [
    {
      name: "User Name",
      key: "userName",
      align: "left",
      width: "332px",
      component: (user) => (
        <Box onClick={() => handleEditFn(user)}>
          <Typography variant="body2" color={tokens.text.primary}>
            {[user?.firstName, user?.lastName].filter(Boolean).join(' ')}
          </Typography>
          <Typography variant="body1" fontSize={tokens.fontSize.base} color={tokens.text.muted}>
            {getFormatedDate(user.createdAt, "date")}
          </Typography>
        </Box>
      ),
    },
    {
      name: "Date Added",
      key: "createdAt",
      align: "left",
      width: "138px",
      component: (user) => (
        <Box onClick={() => handleEditFn(user)}>
          <Typography variant="body2" color={tokens.text.primary}>
            {getFormatedDate(user.createdAt, "date")}
          </Typography>
          <Typography variant="body1" fontSize={tokens.fontSize.base} color={tokens.text.muted}>
            {getFormatedDate(user.createdAt, "time")}
          </Typography>
        </Box>
      ),
    },
    {
      name: "Role",
      key: "userRole",
      align: "center",
      width: "297px",
      component: (user) => (
        <Box onClick={() => handleEditFn(user)}>
          <StyledChip
            role={user?.accessLevel}
            avatar={
              <StyledAvatar
                alt="Not Found"
                src={
                  user?.accessLevel === userRightsEnums.admin
                    ? shield_admin_img
                    : view_only_user_img
                }
              />
            }
            label={user?.accessLevel && formatAndCapitalize(user?.accessLevel)}
            variant="outlined"
          />
        </Box>
      ),
    },
    {
      name: "Actions",
      key: "actions",
      align: "center",
      width: "346px",
      component: (user) => {
        const isRestricted = user?.isRestricted;
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={1}
            onClick={() => handleEditFn(user)}
          >
            <StyledContainedButton
              startIcon={
                isRestricted ? (
                  <IconImage src={unlock_right} size="auto" />
                ) : (
                  <IoMdClose />
                )
              }
              // disabled={!isCurrentUserAdmin}
              onClick={(e) => {
                e.stopPropagation();
                handleEditUser({
                  type: isRestricted ? "unblock" : "restrict",
                  data: user,
                });
              }}
              sx={{
                color: isRestricted
                  ? "rgba(52, 168, 83, 1)"
                  : "rgba(234, 67, 52, 1)",
              }}
              variant="outlined"
              title={isRestricted ? "Unblock" : "Restrict"}
            />

            <Button
              disabled={!isCurrentUserAdmin}
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                handleEditUser({
                  type: "delete",
                  data: user,
                });
              }}
              style={{
                color: tokens.status.danger,
                borderColor: tokens.border.default,
                fontWeight: tokens.fontWeight.semibold,
              }}
            >
              <IconImage src={delete_img} size="auto" />
            </Button>
          </Box>
        );
      },
    },
  ];
};
